import { QuerySuppliersOrderByColumn, SortOrder } from "@/gql/graphql";
import type { SupplierListSearchParams } from "@/app/Suppliers/Routes/supplierRoutes";
import { SupplierListQueryVariables } from "@/app/Suppliers/GraphQL/supplierListQuery";

export function getSupplierListQueryVariables(
  searchParams: SupplierListSearchParams,
  search?: string,
): SupplierListQueryVariables {
  const baseVariables: SupplierListQueryVariables = {
    first: 20,
    page: 1,
  };

  if (search) {
    return {
      ...baseVariables,
      search,
    };
  }

  return {
    ...baseVariables,
    archived: false,
    orderBy: [
      {
        order: SortOrder.Asc,
        column: QuerySuppliersOrderByColumn.Name,
      },
    ],
  };
}
